import React from 'react';
import { MapPin } from 'lucide-react';
import { Badge } from '../ui/badge';

const QuickDestinations = ({ onSelect, language }) => {
  const quickDestinations = [
    { 
      key: 'turin-airport', 
      labelIt: 'Aeroporto Torino',
      labelEn: 'Turin Airport',
      lat: 45.2008, 
      lon: 7.6497,
      type: 'airport'
    },
    { 
      key: 'milan', 
      labelIt: 'Milano',
      labelEn: 'Milan',
      lat: 45.4642, 
      lon: 9.1900,
      type: 'city'
    },
    { 
      key: 'malpensa', 
      labelIt: 'Malpensa',
      labelEn: 'Malpensa Airport',
      lat: 45.6306, 
      lon: 8.7281,
      type: 'airport'
    },
    { 
      key: 'langhe', 
      labelIt: 'Langhe',
      labelEn: 'Langhe',
      lat: 44.6996, 
      lon: 8.0370,
      type: 'region'
    },
    { 
      key: 'sestriere', 
      labelIt: 'Sestriere',
      labelEn: 'Sestriere',
      lat: 45.0358, 
      lon: 6.8790,
      type: 'mountain'
    },
    { 
      key: 'genoa', 
      labelIt: 'Genova',
      labelEn: 'Genoa',
      lat: 44.4056, 
      lon: 8.9463,
      type: 'city'
    }
  ];

  const getTypeEmoji = (type) => {
    switch(type) {
      case 'airport': return '✈️';
      case 'city': return '🏙️';
      case 'mountain': return '🏔️';
      case 'region': return '🍇';
      default: return '📍';
    }
  };

  return (
    <div className="mb-6">
      <p className="text-sm font-semibold text-gray-700 mb-3">
        {language === 'en' ? '🚀 Quick Destinations' : '🚀 Destinazioni Rapide'}
      </p>
      <div className="flex flex-wrap gap-2">
        {quickDestinations.map((dest) => (
          <Badge
            key={dest.key}
            onClick={() => onSelect(dest)}
            className="cursor-pointer bg-gradient-to-r from-amber-50 to-orange-50 border-2 border-amber-200 text-gray-800 hover:from-amber-100 hover:to-orange-100 hover:border-amber-400 transition-all duration-200 px-3 py-2 text-sm font-medium"
          >
            <span className="mr-1">{getTypeEmoji(dest.type)}</span>
            {language === 'en' ? dest.labelEn : dest.labelIt}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default QuickDestinations;
